export const forwardScenes = [
  {
    sceneId: '675166bb97d14bbd943b566d',
    hotspots: [
      {
        hotspotId: '6752949f97d14bbd943b8783',
        overrideOrientation: [
          222.6378467658044, -71.1539437769526, -500.0000000000001,
        ],
      },
      {
        hotspotId: '67516d3097d14bbd943b5a84',
        overrideOrientation: [
          242.0323780226833, -10.446870229865901, -499.99999999999994,
        ],
      },
    ],
  },
  {
    sceneId: '675166c997d14bbd943b5683',
    hotspots: [
      {
        hotspotId: '6752996797d14bbd943b8c08',
        overrideOrientation: [
          500.0000000000001, -28.743070366443625, 128.29148634900514,
        ],
      },
    ],
  },
  {
    sceneId: '675166d897d14bbd943b568f',
    hotspots: [
      {
        hotspotId: '67525d7197d14bbd943b6a47',
        overrideOrientation: [
          154.02168355607344, -5.9738305355912145, -499.99999999999994,
        ],
      },
      {
        hotspotId: '67516eda97d14bbd943b5cb4',
        overrideOrientation: [-500, -24.805853455772795, 306.9255811877304],
      },
    ],
  },
  {
    sceneId: '675166e697d14bbd943b56b0',
    hotspots: [
      {
        hotspotId: '67525d3597d14bbd943b6a1f',
        overrideOrientation: [-3.169728472371562, -32.935068397814334, -500],
      },
    ],
  },
  {
    sceneId: '675166d897d14bbd943b568f',
    hotspots: [
      {
        hotspotId: '67516eda97d14bbd943b5cb5',
        overrideOrientation: [
          189.52444496549055, -89.05433681132405, 500.00000000000006,
        ],
      },
    ],
  },
  {
    sceneId: '675166dd97d14bbd943b569a',
    hotspots: [
      {
        hotspotId: '67516f6f97d14bbd943b5d6e',
        overrideOrientation: [
          -73.4381350328522, -1.0648738345855926, 500.00000000000006,
        ],
      },
    ],
  },
  {
    sceneId: '675166f897d14bbd943b56de',
    hotspots: [
      {
        hotspotId: '67516f9497d14bbd943b5d8d',
        overrideOrientation: [12.324901897550797, -42.36027875885828, -500],
      },
    ],
  },
  {
    sceneId: '675166e297d14bbd943b56a5',
    hotspots: [
      {
        hotspotId: '67516fe597d14bbd943b5e88',
        overrideOrientation: [
          499.99999999999994, -42.901934406983116, 24.044366650420802,
        ],
      },
      {
        hotspotId: '67525d9797d14bbd943b6a6f',
        overrideOrientation: [
          -443.2236944688104, -81.30627287256296, 500.00000000000006,
        ],
      },
    ],
  },
  {
    sceneId: '6751671397d14bbd943b56f5',
    hotspots: [
      {
        hotspotId: '6751703097d14bbd943b5ec9',
        overrideOrientation: [
          -280.8816149144278, -61.079610261506005, -500.00000000000006,
        ],
      },
      {
        hotspotId: '6751703097d14bbd943b5ec8',
        overrideOrientation: [
          -9.147919372805859, -32.308406868455556, -500.00000000000006,
        ],
      },
    ],
  },
  {
    sceneId: '6751671d97d14bbd943b5700',
    hotspots: [
      {
        hotspotId: '6751701097d14bbd943b5ea9',
        overrideOrientation: [
          -340.7807506112765, -166.8961307902202, -499.99999999999994,
        ],
      },
    ],
  },
  {
    sceneId: '675166ee97d14bbd943b56c7',
    hotspots: [
      {
        hotspotId: '67516f0797d14bbd943b5cd6',
        overrideOrientation: [36.974420795935, -79.21334010200309, -500],
      },
    ],
  },
  {
    sceneId: '675166f297d14bbd943b56d2',
    hotspots: [
      {
        hotspotId: '67516f2797d14bbd943b5cf4',
        overrideOrientation: [36.974420795935, -79.21334010200309, -500],
      },
    ],
  },
  {
    sceneId: '675166ea97d14bbd943b56bb',
    hotspots: [
      {
        hotspotId: '67516e3497d14bbd943b5bba',
        overrideOrientation: [
          500.00000000000006, -4.708914701493678, 32.89728124013369,
        ],
      },
      {
        hotspotId: '67516e3497d14bbd943b5bb9',
        overrideOrientation: [
          31.04838338710605, -24.614203510778957, 500.00000000000006,
        ],
      },
    ],
  },
  {
    sceneId: '6751673a97d14bbd943b5719',
    hotspots: [
      {
        hotspotId: '675171e997d14bbd943b610f',
        overrideOrientation: [
          -500.00000000000006, -47.12767432235593, 336.0436858273868,
        ],
      },
    ],
  },
  {
    sceneId: '675166b197d14bbd943b5661',
    hotspots: [
      {
        hotspotId: '67525ec197d14bbd943b6be3',
        overrideOrientation: [500, -46.95966980720669, 203.49876843903783],
      },
    ],
  },
  {
    sceneId: '6751674697d14bbd943b5724',
    hotspots: [
      {
        hotspotId: '675293c697d14bbd943b861e',
        overrideOrientation: [256.7922631471543, 64.39088945513454, -500],
      },
    ],
  },
  {
    sceneId: '675166ab97d14bbd943b5655',
    hotspots: [],
  },
  {
    sceneId: '6751672d97d14bbd943b570c',
    hotspots: [],
  },
  {
    sceneId: '6751675497d14bbd943b5730',
    hotspots: [
      // {
      //   hotspotId: '6751711897d14bbd943b5fbf',
      //   overrideOrientation: [
      //     -416.16569025348315, -91.0364190826539, 500.00000000000006,
      //   ],
      // },
    ],
  },
  {
    sceneId: '675166c097d14bbd943b5678',
    hotspots: [
      {
        hotspotId: '67516d5197d14bbd943b5afa',
        overrideOrientation: [
          499.99999999999994, -36.313815880790344, -200.38361719490476,
        ],
      },
    ],
  },
];

export const mapfloorplanCoors = [
  {
    mapId: '675fd2d8fef38c25a3610698',
    objects: [
      {
        id: '675166c997d14bbd943b5683',
        coordinates: [0.4304, 0.8087],
        //sanh tang 2
      },
      {
        id: '675166dd97d14bbd943b569a',
        coordinates: [0.6826, 0.6043],

        //phong noc
      },
      {
        id: '675166e697d14bbd943b56b0',
        coordinates: [0.4261, 0.6904],
        //phong pccc
      },
      {
        id: '675166ee97d14bbd943b56c7',
        coordinates: [0.1826, 0.712],
        //phong nguon 1
      },
      {
        id: '675166f297d14bbd943b56d2',
        coordinates: [0.287, 0.7077],
        //phong nguon 2
      },
      {
        id: '675166f897d14bbd943b56de',
        coordinates: [0.3087, 0.6017],
        //phong dien co
      },
      {
        id: '6751670497d14bbd943b56e9',
        coordinates: [0.3261, 0.4934],

        // phong server 1
      },
      // {
      //   id: '675166d897d14bbd943b568f',
      //   coordinates: [0.3304, 0.5151],
      // },
      // {
      //   id: '675166e297d14bbd943b56a5',
      //   coordinates: [0.3304, 0.5151],
      // },

      {
        id: '675166ea97d14bbd943b56bb',
        coordinates: [0.2174, 0.7813],

        //phong hang lang truoc nguon
      },
      {
        id: '6751671d97d14bbd943b5700',
        coordinates: [0.3217, 0.3593],
        //phong sever 2
      },
      {
        id: '6751671397d14bbd943b56f5',
        coordinates: [0.2348, 0.2792],

        //phong server 2 - trong
      },
    ],
  },
];
